"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.devAssert=function(e,r){if(!Boolean(e))throw new Error(r)};
//# sourceMappingURL=devAssert.mjs.js.map
